/* GLOBAL AJAX EVENT HANDLER */
$.ajaxSetup({
    success: function (payload) {
        if (payload) {
            if (payload.redirect) {
                if (payload.redirect == 'this') {
                    location.href = window.location.href.split("#")[0];
                } else {
                    location.href = payload.redirect;
                }
            }
            if (payload.snippets) {
                for (var i in payload.snippets) {
                    $("#" + i).replaceWith(payload.snippets[i]);
                }
            }
            if (payload.dialog) {
                $(".part-dialog").remove();
                $("body").addClass("no-scroll-device").append(payload.dialog);
                $("#bgd").fadeIn(300);
                var dialog = $(".part-dialog");
                dialog.addClass("fixed").hide().fadeIn(300);
                var video_width = dialog.find("iframe, video").width();
                var video_height = video_width / (16 / 9);
                dialog.find("iframe, video").css("height", video_height);
            }
            if (payload.alert) {
                alert(payload.alert);
            }
        }
    }
});

// TODO - sjednotit s dialogem //
$(document).on('submit', 'form#detailProductForm', function(e){ 
   e.preventDefault();
   var that = $(this);
   $.ajax({
        method: 'post',
        dataType: 'html',
        data: that.serialize(),
        // url: $el.data('dialog')
    }).done(function (data) {
        $(document).find(".elm_dialog_content *").html("");
        if (!$(document).find(".part_dialog").length) {
            $("body").addClass("mod--no-scroll").append('<div class="part_dialog"><button class="elm_dialog_background"></button><div class="elm_dialog_content"><button class="elm_dialog_close" data-dialog-close></button></div></div>');
        }
        $(document).find(".elm_dialog_content").append(data).hide().fadeIn(300);
        $(document).find(".elm_dialog_background").fadeIn(300);
        $(document).find("[data-last-word]").nl_last_word();
    });
});

$(document).on('submit', 'form#dialogProductForm', function(e){ 
   e.preventDefault();
   var that = $(this);
   that.find('button').prop('disabled', true);
   
   $.ajax({
       method: 'post',
        data: that.serialize(),
        url: that.attr( "action" )
    }).done(function (data) {

        that.find('.elm_status').hide();
        that[0].reset();
        if (data === 'success'){
            that.find('.mod--good').show();
        }
        else if (data === 'failed'){
            that.find('.mod--bad').show();
        }
    });
});


$(document).on('click', '[data-load-more]', function(e){
   e.preventDefault();
   var that = $(this);
   that.addClass('animated--load');
   $.ajax({
        dataType: 'json',
        url: that.attr('href')
    }).done(function (data) {
        $('[data-load-more-items]').append(data.items);
        that.replaceWith(data.btn);
    });
    
});

$(document).on('click', '.icon--save', function(e){
    $(this).attr('href',$('a[aria-hidden="false"]').attr('href'));
});